import React from 'react'
import { toAbsoluteUrl } from '../../_metronic/_helpers'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../_metronic/_partials/controls'


export default function WixSync() {
    return (
        <Card>
            <CardHeader title={<span style={{ marginRight: '5px' }}>
                <img src={toAbsoluteUrl("/media/platforms/wix.png")} alt="" title="Wix Portal" height="32" width="32" style={{ marginRight: '5px' }}></img>Wix - Products Sync
            </span>}>
                <CardHeaderToolbar>
                </CardHeaderToolbar>
            </CardHeader>{" "}
            <CardBody>
                <a
                    type='button'
                    className='btn btn-outline-primary my-3'
                    style={{cursor:'not-allowed'}}
                    // href='https://wixapp.ccdemostore.com/api/product_multi_import.php'
                // onClick={}
                >
                    <i class="fa fa-angle-right" aria-hidden="true"></i> ProductSync Step1
                </a><br />
                <a
                    type='button'
                    className='btn btn-outline-primary'
                    // href="https://wixapp.ccdemostore.com/api/importProduct.php"
                    style={{cursor:'not-allowed'}}
                // onClick={}
                >
                    <i class="fa fa-angle-right" aria-hidden="true"></i> ProductSync Step2
                </a>
            </CardBody>
        </Card>
    )
}
